export default __webpack_public_path__ + "static/media/songpagu-bangidong-urbanloft-3.d29256b7.jpg";